export default __webpack_public_path__ + "static/media/dino_showroom_bussi.81c7173c.jpg";